import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { filter, findIndex, includes, sortBy } from 'lodash';
import { scroller } from 'react-scroll';
import TagManagementTabMainWrap from '../../views/tag/management/tabMain/TagManagementTabMainWrap';
import { appActions } from '../../store/modules/app';
import { tagActions } from '../../store/modules/tag';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { TAG_LINK_LIST_FILTER_OPTION_MODEL, TAG_LINK_LIST_SORT_OPTION_MODEL } from '../../store/modules/tag/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';
import {
  TAG_TAB_MAIN_ITEM_COUNT,
  TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME,
  TAG_TAB_MAIN_SECTION_TYPE,
} from '../../constants/service/app/tagConstants';
import { asyncSimpleModal } from '../../lib/common';

class TagTabMainManagementContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  초기 데이터 불러오기
   */
  initiate = () => {
    const { getTagTabMainData } = this.props;

    /**
     *  태그 리스트의 필터, 정렬, 방식이 같으므로
     *  처음요청을 할 때는 하나의 검색 옵션으로 요청을 함
     */
    getTagTabMainData({
      option: {
        filterOption: TAG_LINK_LIST_FILTER_OPTION_MODEL,
        sortOption: TAG_LINK_LIST_SORT_OPTION_MODEL,
        pagination: _LIST_PAGINATION_MODEL,
      },
    });
  };

  /**
   *  태그 탭 메인 편집 하기
   */
  onSubmit = () => {
    const { tagTabMain, toggleModal } = this.props;

    /**
     *  트렌드 키워드 태그 id 리스트
     */
    const tagTrendKeywordIdList = tagTabMain[TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST].selectedItemList.idList;

    /**
     *  미리 선정된 팔로우한 태그 리스트
     */
    const tagFollowSelectedList = tagTabMain[
      TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST
    ].selectedItemList.list.map((item, index) => ({
      id: item.id,
      no: index + 1,
    }));

    /**
     *  트렌드 키워드 태그 최소 개수 체크
     */
    const minimumNumberOfTagTrendKeywordCount =
      TAG_TAB_MAIN_ITEM_COUNT[TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST].MINIMUM_NUMBER_OF_ITEM_COUNT;
    if (tagTrendKeywordIdList.length < minimumNumberOfTagTrendKeywordCount) {
      message.error(`트렌드 키워드 태그는 최소 ${minimumNumberOfTagTrendKeywordCount}개이상입니다.`);
      scroller.scrollTo(TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME.TAG_TEND_KEYWORD_LIST);
      return;
    }

    /**
     *  미리 선정된 팔로우한 태그 최소 개수 체크
     */
    const minimumNumberOfTagFollowSelectedCount =
      TAG_TAB_MAIN_ITEM_COUNT[TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST].MINIMUM_NUMBER_OF_ITEM_COUNT;
    if (tagFollowSelectedList.length < minimumNumberOfTagFollowSelectedCount) {
      message.error(`미리 선정된 팔로우한 태그는 최소 ${minimumNumberOfTagFollowSelectedCount}개이상입니다.`);
      scroller.scrollTo(TAG_TAB_MAIN_MANAGEMENT_PAGE_PANEL_NAME.TAG_FOLLOW_SELECTED_LIST);
      return;
    }

    /**
     *  태그 트렌드 키워드 리스트에 대한 메모를 입력 후
     *  태그 탭 메인 컨텐트를 저장할 수 있도록 함.
     */
    toggleModal({
      name: 'editTabMainModal',
      data: {
        tagTrendKeywordIdList,
        tagFollowSelectedList,
      },
      value: true,
    });
  };

  /**
   *  태그 탭 메인 컨텐츠 리스트 불러오기
   */
  getTagTabMainContentsList = (option) => {
    const { getTagTabMainContentsList, tagTabMain } = this.props;
    const { tagTabMainSectionType } = option;
    const { filterOption, sortOption, pagination } = tagTabMain[tagTabMainSectionType].itemList;

    getTagTabMainContentsList({
      tagTabMainSectionType,
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   *  태그 탭 메인 컨텐츠 리스트 선택하기
   */
  selectTagTabMainContentsList = async (action, moveIdList, tagTabMainSectionType) => {
    const { setData, tagTabMain } = this.props;
    const { itemList, selectedItemList } = tagTabMain[tagTabMainSectionType];

    /**
     *  업데이트 될 선택된 태그 탭 메인 컨텐츠 리스트
     */
    let updatedSelectTagTabMainContentsList = [];

    /**
     *  태그 탭 메인 컨텐츠 리스트 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList.list, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 위젯 아이템을 합침
       */
      updatedSelectTagTabMainContentsList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 트렌드 키워드 리스트 개수가 초과되었을 경우
       */
      if (
        updatedSelectTagTabMainContentsList.length >
        TAG_TAB_MAIN_ITEM_COUNT[tagTabMainSectionType].MAXIMUM_NUMBER_OF_ITEM_COUNT
      ) {
        await asyncSimpleModal({
          type: 'error',
          title: '선택된 아이템 개수 초과',
          message: `해당 아이템 개수는 최대 ${TAG_TAB_MAIN_ITEM_COUNT[tagTabMainSectionType].MAXIMUM_NUMBER_OF_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  태그 탭 메인 컨텐츠 리스트 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectTagTabMainContentsList = filter(selectedItemList.list, (item) => !includes(moveIdList, item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedTagTabMainContentsList = itemList.list.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['tagTabMain', tagTabMainSectionType, 'itemList', 'list'],
      value: updatedTagTabMainContentsList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['tagTabMain', tagTabMainSectionType, 'selectedItemList'],
      value: {
        list: updatedSelectTagTabMainContentsList,
        idList: updatedSelectTagTabMainContentsList.map((item) => item.id),
      },
    });
  };

  /**
   * 태그 탭 메인 컨텐츠 리스트 순서 변경하기
   */
  onDragEndSelectTagTabMainContentsList = async (newList, tagTabMainSectionType) => {
    const { setData, tagTabMain } = this.props;
    const { selectedItemList } = tagTabMain[tagTabMainSectionType];

    const updatedSelectTagTabMainContentsList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['tagTabMain', tagTabMainSectionType, 'selectedItemList'],
      value: {
        list: updatedSelectTagTabMainContentsList,
        idList: updatedSelectTagTabMainContentsList.map((item) => item.id),
      },
    });
  };

  /**
   *  태그 탭 메인 미리보기
   */
  tagTabMainPreview = () => {
    const { getTagTabMainPreviewData, tagTabMain } = this.props;

    getTagTabMainPreviewData({
      /**
       *  선택된 트렌드 키워드의 태그 id 리스트
       */
      tagTrendKeywordTagIdList: tagTabMain[TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST].selectedItemList.idList,
      /**
       *  미리 선정된 팔로우한 태그의 태그 id 리스트
       */
      tagFollowSelectedIdList: tagTabMain[TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST].selectedItemList.idList,
    });
  };

  /**
   *  전체 태그 리스트 엑셀 다운로드
   */
  getTagTabMainAllListExcelDownload = (tagTabMainSectionType) => {
    const { getTagTabMainAllListExcelDownload, tagTabMain } = this.props;

    getTagTabMainAllListExcelDownload({
      filterOption: tagTabMain[tagTabMainSectionType].itemList.filterOption,
      sortOption: tagTabMain[tagTabMainSectionType].itemList.sortOption,
    });
  };

  /**
   *  선택된 태그 리스트 엑셀 다운로드
   */
  getTagTabMainSelectedListExcelDownload = (tagTabMainSectionType) => {
    const { getTagTabMainSelectedListExcelDownload, tagTabMain } = this.props;
    const { idList } = tagTabMain[tagTabMainSectionType].selectedItemList;

    if (!idList.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getTagTabMainSelectedListExcelDownload({
      tagIdList: idList,
    });
  };

  /**
   *  태그 엑셀 업로드
   */
  setTagTabMainExcelUpload = (file, type) => {
    const { setTagTabMainExcelUpload } = this.props;

    setTagTabMainExcelUpload({
      attachment: [file],
      tagTabMainSectionType: type,
    });
  };

  render() {
    const { tagTabMain, getRelatedTagList } = this.props;

    return (
      <TagManagementTabMainWrap
        tagTabMain={tagTabMain}
        getRelatedTagList={getRelatedTagList}
        onSubmit={this.onSubmit}
        getTagTabMainContentsList={this.getTagTabMainContentsList}
        selectTagTabMainContentsList={this.selectTagTabMainContentsList}
        onDragEndSelectTagTabMainContentsList={this.onDragEndSelectTagTabMainContentsList}
        tagTabMainPreview={this.tagTabMainPreview}
        getTagTabMainAllListExcelDownload={this.getTagTabMainAllListExcelDownload}
        getTagTabMainSelectedListExcelDownload={this.getTagTabMainSelectedListExcelDownload}
        setTagTabMainExcelUpload={this.setTagTabMainExcelUpload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagTabMain: state.tag.tagTabMain,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  getTagTabMainData: tagActions.getTagTabMainData,
  getTagTabMainContentsList: tagActions.getTagTabMainContentsList,
  getTagTabMainPreviewData: tagActions.getTagTabMainPreviewData,
  getTagTabMainAllListExcelDownload: tagActions.getTagTabMainAllListExcelDownload,
  getTagTabMainSelectedListExcelDownload: tagActions.getTagTabMainSelectedListExcelDownload,
  setTagTabMainExcelUpload: tagActions.setTagTabMainExcelUpload,
  toggleModal: tagActions.toggleModal,
  getRelatedTagList: appActions.getRelatedTagList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagTabMainManagementContainer);
